// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"_a4b0f62c"};